import React, { useMemo } from "react";
import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "components/Common/ChartsDynamicColor";

const ChartApex = ({ dataColors, chartData, filterType }) => {
  const apaexlineChartColors = getChartColorsArray(dataColors);

  let totalSuccessCount = 0;
  let totalFailCount = 0;
  const { series, categories } = useMemo(() => {
    const SuccessCount = [];
    const FailCount = [];
    const categoryLabels = [];

    if (Array.isArray(chartData)) {
      chartData.forEach(item => {
        categoryLabels.push(item?.YearMonthDay?.toString?.() || "");

        const c = item?.SuccessCount ?? 0;
        const v = item?.FailCount ?? 0;

        SuccessCount.push(c);
        FailCount.push(v);

        totalSuccessCount += c;
        totalFailCount += v;
      });
    }
    return {
      categories: categoryLabels,
      series: [
        { name: `Success`, data: SuccessCount },
        { name: `Fail`, data: FailCount },
      ],
      totals: {
        totalSuccessCount,
        totalFailCount,
      }
    };
  }, [chartData]);

  const options = {
    chart: {
      height: 380,
      type: 'line',
      zoom: { enabled: false },
      toolbar: { show: false }
    },
    colors: apaexlineChartColors,
    dataLabels: { enabled: false },
    stroke: { width: [3, 3], curve: 'straight' },
    title: {
      text: 'Customer Attend Chart Report',
      align: 'left',
      style: { fontWeight: '500' },
    },
    grid: {
      row: { colors: ['transparent', 'transparent'], opacity: 0.2 },
      borderColor: '#f1f1f1'
    },
    markers: { style: 'inverted', size: 6 },
    xaxis: {
      categories: categories,
      title: { text: filterType }
    },
    yaxis: {
      title: { text: 'Count' },
      min: 0
    },
    legend: {
      position: 'top',
      horizontalAlign: 'right',
      floating: true,
      offsetY: -25,
      offsetX: -5
    },
    responsive: [{
      breakpoint: 600,
      options: {
        chart: { toolbar: { show: false } },
        legend: { show: false }
      }
    }]
  };

  return (
    <>
      <div className="" style={{ display: "flex", justifyContent: "end", gap: "20px" }}>
        <span><strong>Total Success:</strong> {totalSuccessCount}</span>
        <span><strong>Total Fail:</strong> {totalFailCount}</span>
        <span><strong>Total:</strong> {totalSuccessCount + totalFailCount}</span>
      </div>
      <ReactApexChart
        options={options}
        series={series}
        type="line"
        height="380"
        className="apex-charts"
      />
    </>
  );
};

export default ChartApex;
